import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';

import AdditionalServices from './components/AdditionalServices';
// import Contact from './components/Contact';
// import Testimonials from './components/Testimonials';

const App = ({ initialPage }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const isServicesPage = initialPage === 'services' || location.pathname === '/services';

  useEffect(() => {
    document.documentElement.classList.add('dark');
  }, []);

  useEffect(() => {
    if (isServicesPage) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    if (location.hash === '#services') {
      document.getElementById('services')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }

    if (location.hash === '#home') {
      document.getElementById('home')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }

    if (!location.hash) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [location.hash]);

  return (
    <div className="relative isolate min-h-screen w-full overflow-x-hidden bg-[#050505] text-white">
      <div className="relative z-10">
        <Navbar />
        <main>
          {isServicesPage ? (
            <AdditionalServices navigateToHome={() => navigate('/home')} />
          ) : (
            <>
              <Hero />

              {/* <Testimonials /> */}
              {/* <Contact /> */}
            </>
          )}
        </main>
      </div>
    </div>
  );
};

export default App;
